export default __webpack_public_path__ + "static/media/65.f9adbb1a.jpeg";